var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80742 0H26.7736C27.1619 0 27.5346 0.154495 27.8093 0.429153L37.2232 9.84306C37.4978 10.1177 37.6523 10.4904 37.6523 10.8788V45.3972C37.6523 47.9351 35.5874 50 33.0495 50H4.80742C2.27675 50 0.204605 47.9538 0.204605 45.3972V4.60281C0.204605 2.07214 2.25043 0 4.80742 0ZM26.6694 3.43208V9.30977C26.6694 10.2325 27.4198 10.9829 28.3426 10.9829H34.2203L26.6694 3.43208ZM3.13429 45.3972C3.13429 46.3085 3.87091 47.0703 4.80742 47.0703H33.0495C33.9719 47.0703 34.7227 46.3196 34.7227 45.3972V13.913H28.3426C25.8047 13.913 23.7398 11.8481 23.7398 9.31015V2.92969H4.80742C3.89571 2.92969 3.13429 3.66669 3.13429 4.60281V45.3972Z",
    fill: "#D59B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.697cc4b0db76ec04ddcadf16bdacdb9e.svg";
export { ForwardRef as ReactComponent };